export default function ProfilePicture({ src, alt }) {
	const style = {
		borderRadius: "50%",
		objectFit: "cover",
		display: "block",
		border: "solid 3px black",
	};
	return <img src={src} alt={alt} style={style} />;
}
